import React from 'react';
import {
  HStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import {
  FiInfo,
  FiMessageSquare,
  FiDatabase,
  FiLink,
} from 'react-icons/fi';
import InfoTab from './ModalTabsComponents/RightModalComponents/InfoTab';
import ChatTab from './ModalTabsComponents/RightModalComponents/ChatTab';
import EntityTab from './ModalTabsComponents/RightModalComponents/EntityTab';
import LinkTab from './ModalTabsComponents/RightModalComponents/LinkTab';

const ModalRightSection = ({ task, columns, setColumns, moveCardAPI }) => {
  return (
    <Tabs isFitted variant="enclosed">
      <TabList mb="1em">
        <Tab>
          <HStack spacing={2}>
            <FiInfo />
            {/* <span>Info</span> */}
          </HStack>
        </Tab>
        <Tab>
          <HStack spacing={2}>
            <FiDatabase />
            {/* <span>Entity</span> */}
          </HStack>
        </Tab>
        <Tab>
          <HStack spacing={2}>
            <FiMessageSquare />
            {/* <span>Chat</span> */}
          </HStack>
        </Tab>
        <Tab>
          <HStack spacing={2}>
            <FiLink />
            {/* <span>Chat</span> */}
          </HStack>
        </Tab>

      </TabList>

      <TabPanels>
        {/* Info Tab */}
        <TabPanel>
          <InfoTab
            task={task}
            columns={columns}
            setColumns={setColumns}
            moveCardAPI={moveCardAPI}
          />

        </TabPanel>

        {/* Entity Tab */}
        <TabPanel>
          <EntityTab task={task} />
        </TabPanel>

        {/* Chat Tab */}
        <TabPanel px={0}>
          <ChatTab task={task} />
        </TabPanel>

        {/* Link Tab */}
        <TabPanel px={0}>
          <LinkTab task={task} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default ModalRightSection;